import * as React from "react";
import { useGetLanguagesQuery } from "../../services/language.service";
import { Language } from "../../types/language";
import SelectBase, { SelectOption } from "../../components/global/SelectBase";

const SelectLanguages = ({
  onChange,
  values,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
}) => {
  const { data, isLoading, isFetching } = useGetLanguagesQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const languages: Array<Language> = React.useMemo(() => {
    return (
      data?.filter((it) =>
        ["en", "vi", "es", "zh", "ar", "fr", "hi", "ot"].includes(it.code)
      ) || []
    );
  }, [data]);

  const options = React.useMemo<SelectOption[]>(() => {
    return languages.map((lang) => ({
      label: lang.name,
      value: lang.id,
    }));
  }, [languages]);

  const selectedValues = React.useMemo<SelectOption[]>(() => {
    return options?.filter((it) => values?.includes(it.value as number)) || [];
  }, [options, values]);

  return (
    <SelectBase
      options={options}
      value={selectedValues}
      onChange={(newValue) => {
        const options = newValue as SelectOption[] | null;
        onChange(options?.map((it) => it.value as number));
      }}
      label="Languages"
      placeholder="Search..."
      isMulti={true}
      isSearchable={true}
      isLoading={isLoading || isFetching}
    />
  );
};
export default SelectLanguages;
